// src/components/IntroSection2.js

import React, { useState, useEffect, useRef } from 'react';
import './IntroSection2.css';
import { useNavigate } from 'react-router-dom';

const IntroSection2 = () => {
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  const handleNavigateToContact = () => {
    navigate('/contactUs');
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const headlineText = "LIGHT & FORM";
  const letters = headlineText.split('');

  return (
    <section ref={sectionRef} className={`intro-section-2 ${isInView ? 'is-in-view' : ''}`}>
      <div className="content-wrapper">
        <h1 className="fragmented-headline" aria-label={headlineText}>
          {letters.map((letter, index) => (
            letter === ' '
              ? <span key={index} className="fragment-letter-space"> </span>
              : <span
                key={index}
                className="fragment-letter"
                style={{ transitionDelay: `${Math.random() * 0.5}s` }}
                aria-hidden="true"
              >
                {letter}
              </span>
          ))}
        </h1>

        <p className="description-paragraph">
          We are artisans of illumination, creating lighting designs that are both functional statements and breathtaking works of art.
        </p>

        {/* ===== MODIFICATION START: Replaced <a> with <button> ===== */}
        <button className="cta-link" onClick={handleNavigateToContact}>
          Collaborate With Us
        </button>
        {/* ===== MODIFICATION END ===== */}

      </div>

      <div className="scroll-indicator">
        <span>Scroll Down</span>
        <div className="indicator-line"></div>
      </div>
    </section>
  );
};

export default IntroSection2;